type ReportRouteFlags = {
  manual?: boolean;
  picker?: boolean;
  manualDrilldown?: boolean;
};

const REPORT_ROUTE_QUERY_FLAG_KEYS = ['manual', 'picker', 'manualDrilldown'] as const;

let pendingFlags: ReportRouteFlags = {};

export const isReportRouteParamFlag = (value: unknown) => {
  if (value === true) return true;
  if (value === false || value == null || value === '') return false;
  if (typeof value !== 'string') return false;
  return value === '1' || value === 'true';
};

export const primeReportRouteFlags = (flags: ReportRouteFlags) => {
  pendingFlags = { ...flags };
};

const consumePendingReportRouteFlag = (key: 'manual' | 'manualDrilldown') => {
  const pending = !!pendingFlags[key];
  pendingFlags[key] = false;
  return pending;
};

export const hasReportRouteManualFlag = (params: Record<string, unknown>) =>
  isReportRouteParamFlag(params.manual) || consumePendingReportRouteFlag('manual');

export const hasReportRouteManualDrilldownFlag = (params: Record<string, unknown>) =>
  isReportRouteParamFlag(params.manualDrilldown) ||
  consumePendingReportRouteFlag('manualDrilldown');

export const reportRouteParams = (flags: ReportRouteFlags) => {
  primeReportRouteFlags(flags);
  return {} as Record<string, never>;
};

export const replaceReportRoute = (
  router: { replace: (to: unknown) => unknown },
  location: unknown,
  onComplete?: () => void,
) => {
  const done = () => {
    onComplete?.();
  };
  Promise.resolve(router.replace(location)).then(done, done);
};

export const stripReportRouteQueryFlags = (query: Record<string, unknown>) => {
  const cleaned = { ...query };
  let changed = false;
  for (const key of REPORT_ROUTE_QUERY_FLAG_KEYS) {
    if (key in cleaned) {
      delete cleaned[key];
      changed = true;
    }
  }
  return changed ? cleaned : null;
};
